import {Component, EventEmitter, Inject, Output, OnInit, Input, ViewChild, SimpleChanges} from '@angular/core';
import {ConnectorsService} from '../../connectors.service';
import {ConfService} from '../../conf.service';
import {AuthorizationComponent} from '../../authorization/authorization.component';
import {FormControl, NgModel} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {DataService} from '../../data-catalogue/er-diagram/service/data.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {ListenerService} from '../../listener.service';
import {KongService} from '../../kong.service';
import {AccountInfoService} from '../../user/account-info.service';
import {Location} from '@angular/common';
import {HttpHeaders} from '@angular/common/http';
import exportFromJSON from 'export-from-json';
import {environment} from '../../../environments/environment';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {AttributesListComponent} from '../../attributes-list/attributes-list.component';
import {AppComponent} from '../../app.component';
import {HeadersComponent} from '../../devex/headers/headers.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {DevexListenerService} from '../../devex-listener.service';
import {ApigatewayListenerService} from '../../apigateway-listener.service';
import {AccessPolicyService} from '../../access-policy.service';
import {CookieService} from 'ngx-cookie-service';
import {CodeViewerComponent} from '../../devex/api1/language-commands/ace-editor/code-viewer.component';
import {AuditLogService} from '../../audit-log.service';
import {DefaultApiUrlComponent, DeployAsApiComponent} from 'src/app/devex/devex.component';

const incr = 7;
declare let $;

export interface ConfirmationData {
  confirmation: string;
}

interface Main {
  value: string;
  viewValue: string;
}

interface Type {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-add-data-source',
  templateUrl: './add-data-source.component.html',
  styleUrls: ['./add-data-source.component.scss']
})
export class AddDataSourceComponent implements OnInit {

  @Input() mockResponses = [];
  @Input() entity: string;
  @Input() version: string;
  @Input() partner = localStorage.getItem('partner');
  @Input() account_id = localStorage.getItem('account');
  @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
  @Input() account = localStorage.getItem('account');
  @Input() pkey = localStorage.getItem('partnerKey');
  @Output() closeDialog = new EventEmitter<{ connector: any; connectorImage: any; executor: any }>();
  selectedConnector: any;
  selectedDataSource: String = '';
  imageUrl: any;
  executorDisplayNames: any;
  connectorListLabel: String = '';
  connectorList: any[] = [];
  connectors: any = {};
  executors: any;
  executorsData: any;
  platformServiceProviders: any;
  serviceProviders: any;
  selectedVersion: string;
  selectedExecutor: any;
  viewResponse: any;
  selectedConnectorType: any;
  selectedExecutorType: any;
  executorMethods = [
    {name: 'GET'},
    {name: 'POST'},
    {name: 'PUT'},
    {name: 'DELETE'}
  ];
  executor_display_name: String[] = [];
  selectedDatabaseObjectTypes: any;
  databaseObjectTypeFilter: any = [];
  description: String;
  queryParams = [];
  requestBody = {};
  executorCategory: string;
  scopeSelected = 'public';
  orig_executor: any;
  orig_executor_name: any;
  orig_executor_version: any;
  serviceTaskConfig: any;
  headers = [];
  dataDictionaryError = '';
  editFlag: boolean;
  partnerKey = localStorage.getItem('partnerKey');
  apiKey = localStorage.getItem('apikey');
  apiSearchInputCrtl = new FormControl();
  loaderDialog: any;
  dataLoading: boolean;
  filterData: any[];
  itemList: any[];
  searchText: any;
  loading = false;
  error = false;
  items: any;
  userView = 'table';
  columns1: string[] = [];
  options: any;
  itemLength: any;
  errorMessage: string;
  selectedApi: string;
  data: any;
  dataErrorMessage: string;
  apiConnectorType: any;
  apiList: any;
  @ViewChild(AttributesListComponent) child;
  @ViewChild('form1', {static: false}) public MyForm1: NgModel;
  @ViewChild('form2', {static: false}) public MyForm2: NgModel;
  @Input() componentType = 'devex';
  disableMethodSelector = true;
  disableAPIUrlInput = true;
  @Input() showUpdateApi = true;
  @Input() showHelpButton = true;
  @Input() componentName: string;
  apiByDefinition: any;
  @Input() isBodyParamEnabled = false;
  @Input() bodyParamDescription = [];
  isSaveAPI = false;
  selectedIndex = 0;
  selected = new FormControl(0);
  language: string;
  executeFlag: any;
  attributes: any;
  apiByDefinition2: any;
  operations: any;
  operations1: any;
  params: any;
  responseType: any;
  response: any;
  getResponse: any;
  getRequest: any;
  getHttpOptions: any;
  putResponse: any;
  putRequest: any;
  putHttpOptions: any;
  dataModelPost: any;
  dataModelPut: any;
  postResponse: any;
  postRequest: any;
  postHttpOptions: any;
  dataModel: any;
  dataSource: any;
  deleteResponse: any;
  deleteRequest: any;
  deleteHttpOptions: any;
  parametersHeaders = ['key', 'value', 'description'];
  parameterData = [];
  pathParameter = [];
  headersData = [];
  formData = [];
  @Input() requestBodySelected = 'none';
  confirmationWithoutResponseAttributes = {confirmation: ''};
  requestBodyTypes = [
    {'displayName': 'None', 'value': 'none'},
    {'displayName': 'Form Data', 'value': 'form-data'},
    {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
    {'displayName': 'Raw', 'value': 'raw'},
    {'displayName': 'Binary / File', 'value': 'binary'}

  ];
  httpOperation = 'GET';
  httpOperations = [
    {'name': 'GET'},
    {'name': 'POST'},
    {'name': 'PUT'},
    {'name': 'PATCH'},
    {'name': 'DELETE'},
    {'name': 'COPY'},
    {'name': 'HEAD'},
    {'name': 'OPTIONS'},
    {'name': 'LINK'},
    {'name': 'UNLINK'},
    {'name': 'LOCK'},
    {'name': 'UNLOCK'},
    {'name': 'PROPFIND'},
    {'name': 'PURGE'},
    {'name': 'VIEW'}
  ];
  @Input() executor: any;
  httpUrl: string;
  execute: boolean;
  save: boolean;
  update: boolean;
  rawRequestBody: any;
  responseBody: any;
  @Input() devexgeneric = true;
  @Input() showResponseSection = true;
  @Input() showRegister = true;
  @Input() showExecuteButton = true;
  @Input() showTestButton = false;
  languages: any;
  languageSelected = 'en';
  columns: string[] = [];
  navigate: any;
  settings = {
    text: 'Select attribute(s) to search',
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class'
  };
  isResponseAttributesPresent = false;
  responseCookies: any;
  responseCode: any;
  responseData: any;
  responseText: any;
  responseItems: any;
  responses: any;
  responseObject: any;
  responseError: any;
  responseTimestamp: any;
  responseHeaders: any;
  responseTime: any;
  executorDescription: string;
  executorName: string;
  executorVersion: string;
  executor_url: string;
  passed_executor_description: string;
  @Input() executor_name: string;
  @Input() executor_version: string;
  @Input() executor_type = 'API';
  executor_method_type: string;
  pathParams: any;
  selectAuth: any;
  authAttributes = {};
  authModel = {
    'authAttributes': this.authAttributes
  };
  @ViewChild(HeadersComponent) devexHeader: HeadersComponent;
  prerequisites: any;
  servicedata: any;
  routehostdata: any;
  routepathdata: any;
  ratelimitingOrig: any;
  keyauthOrig: any;
  ipRestriction: any;
  cors: any;
  acl: any;
  gatewayUrl: string;
  @Input() showNextPanel = false;
  url = environment.apihost;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild(HeadersComponent) headerChild: HeadersComponent;
  @ViewChild('codeViewer') codeViewer: CodeViewerComponent;
  options1 = new JsonEditorOptions();
  showPathParameters: boolean;
  devExURL = '';
  isCountOfResAtt: boolean;
  pathParameterSegregator: any;
  find: any;
  pathParameterStopper: any;
  pathParameterValue: any;
  updateApi = false;
  contentType: any;
  isUpdating = false;
  showHideData: any;
  formDataTrue = true;
  formURLEncodedTrue = true;
  selector: any;
  returnType = '';
  myControl = new FormControl();
  @Input() businesslogic: boolean;
  @Input() sourceExecutor: any;
  sourceOperations1: any;
  @Input() parentParams: any;
  @Output() tabNameChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() isApiDiscovery: boolean;
  jsonViewer: any;
  htmlViewType = 'raw';

  constructor(public dialogRef: MatDialogRef<AddDataSourceComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: any,
              private connectorsService: ConnectorsService,
              public dataService: DataService,
              public listenerInstance: ListenerService,
              private _service: ConnecttocrudService,
              private confPost: ConfService,
              private kongService: KongService,
              private accountInfoService: AccountInfoService,
              private auditLog: AuditLogService,
              private location: Location,
              private leftPanelDataListener: ListenerService,
              private accessPolicyService: AccessPolicyService,
              private route: ActivatedRoute,
              private appComp: AppComponent,
              private devexListenerInstance: DevexListenerService,
              public snackBar: MatSnackBar,
              private router: Router,
              private Urlroute: ActivatedRoute,
              public dialog: MatDialog,
              private apiGatewayListenerInstance: ApigatewayListenerService,
              private cookieService: CookieService,
              public platform: LeftpanelComponent
  ) {
    // console.log(this.dialogData);
    this.connectors = this.dialogData['connectors'];

    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/*this.editor.get()*/);
  }

  async ngOnInit() {
    this.executor_name = undefined;
    this.selectedVersion = undefined;
    this.executor_display_name = undefined;
    this.description = undefined;
    this.executorCategory = undefined;
    this.scopeSelected = 'public';
    this.queryParams = [];
    this.headers = [];
    this.mockResponses = [];
    this.requestBody = [];
    this.gatewayUrl = 'https://' + await this.platform.getDefaultGatewayURL();
    this.showPathParameters = false;
    if (this.dialogData['type'] === 'edit') {
      this.selectedConnector = this.dialogData['connectorData']['connector']['name'];
      this.selectedExecutor = this.dialogData['connectorData']['executor'];
      this.imageUrl = this.dialogData.connectorData.connectorImage;
      this.apiConnectorType = this.dialogData.connectorData.connector.type;
      this.onSelectConnector();
      this.OnExecutorSelect();
    }
  }

  onSelectConnector() {
    if (this.selectedConnector) {
      const connectorName = this.selectedConnector;
      const apiConnector = this.connectors.api.find(api => api.name === connectorName);
      const databaseConnector = this.connectors.database.find(db => db.name === connectorName);
      if (apiConnector) {
        this.apiConnectorType = apiConnector.type;
        this.selectedConnectorType = 'api';
        this.getProducerData();
        this.getExecutorsData();
      } else if (databaseConnector) {
        this.selectedConnectorType = 'database';
      }
    }
    return null;
  }

  addDataSource(): void {
    const connectorName = this.selectedConnector;
    const PassConnector = this.connectors.api.find(api => api.name === connectorName);
    const PassExecutor = this.selectedExecutor;
    const PassImage = this.imageUrl;
    this.closeDialog.emit({connector: PassConnector, connectorImage: PassImage, executor: PassExecutor});
    this.dialogRef.close({connector: PassConnector, connectorImage: PassImage, executor: PassExecutor});
  }

  cancel() {
    this.dialogRef.close();
  }

  getProducerData() {
    this.connectorsService.getData('services', 'services', 'v1', 'apiproducers', 'partner=services' + '&account=services' + '&producer=' + encodeURIComponent(this.apiConnectorType)).subscribe(platformProviders => {
      this.serviceProviders = platformProviders;
      this.imageUrl = platformProviders[0].image;
    }, error => {
      this.platform.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
        duration: 15000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  databaseObjectsSelected() {

  }

  async getExecutorsData() {
    try {
      const data = await this.connectorsService.getExecutors(this.apiConnectorType).toPromise();
      this.executorsData = data;
      this.executors = this.executorsData.flatMap(executor =>
          executor.categories.flatMap(category =>
              category.executors.map(e => ({
                id: e.id,
                executor_name: e.executor_name,
                executor_version: e.executor_version,
                executor_description: e.executor_description,
                apiUrl: e.apiUrl,
                executor_type: e.executor_type,
                executor_method_type: e.executor_method_type,
                queryParams: e.queryParams,
                pathParams: e.pathParams,
                authModel: e.authModel,
                headers: e.headers,
                prerequisites: e.prerequisites,
                requestBody: e.requestBody,
                mockResponses: e.mockResponses,
              }))
          )
      );
    } catch (error) {
      console.error('Error fetching executors data:', error);
    }
  }

  OnExecutorSelect() {
    if (this.selectedExecutor) {
      this.executor = this.selectedExecutor;
      this.httpUrl = this.selectedExecutor.apiUrl;
      this.executorDescription = this.selectedExecutor.executor_description;
      this.executor_name = this.selectedExecutor.executor_name;
      this.executor_version = this.selectedExecutor.executor_version;
      this.executor_type = this.selectedExecutor.executor_type;
      this.executor_method_type = this.selectedExecutor.executor_method_type;
      this.httpOperation = this.selectedExecutor.executor_method_type;
      this.parameterData = this.selectedExecutor.queryParams;
      this.pathParameter = this.selectedExecutor.pathParams;
      this.authModel = this.selectedExecutor.authModel;
      this.headersData = this.selectedExecutor.headers;
      this.requestBody = this.selectedExecutor.requestBody;
      this.mockResponses = this.selectedExecutor.mockResponses;
      this.prerequisites = this.selectedExecutor.prerequisites;
    }
  }

  checkQueryParams(event) {
    const tempUrl = event.target.value;
    const seperator = tempUrl.split('/');
    let query: any;
    let finalquery: any;
    if (seperator.length > 0) {
      query = seperator[seperator.length - 1].split('?');
      if (query.length > 1) {
        finalquery = query[query.length - 1].split('&');
        if (finalquery) {
          for (let i = 0; i < finalquery.length; i++) {
            const temp = finalquery[i].split('=');
            let flag = false;
            for (let j = 0; j < this.parameterData.length; j++) {
              if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                flag = true;
                if (temp.length > 1) {
                  this.parameterData[j]['key'] = temp[0];
                  this.parameterData[j]['value'] = temp[1];
                } else {
                  this.parameterData[j]['key'] = temp[0];
                  this.parameterData[j]['value'] = '';
                }
              }
            }
            if (flag === false) {
              if (temp.length > 1) {
                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
              } else {
                this.parameterData.push({key: temp[0], value: '', description: ''});
              }
            }
          }
        }
      }
    }
  }

  parameterDataCheck(event: any) {
    if (this.devExURL !== event.target.value) {
      this.devExURL = event.target.value;

      const querySeparator = this.devExURL.split('?');

      const protocolSeparator = querySeparator[0].split('://');
      const hostPath = protocolSeparator[protocolSeparator.length - 1].split('/');
      if (hostPath.length > 1) {
        hostPath.splice(0, 1);
      }
      const path = hostPath.join('/');
      const pathParamaterAssigner = path.split(':');
      let finalPathString = '';

      for (let i = 1; i < pathParamaterAssigner.length; i++) {
        if (pathParamaterAssigner[i]) {
          finalPathString = finalPathString + '/:' + pathParamaterAssigner[i];
        }
      }
      this.pathParameterSegregator = finalPathString.split('/:');
      for (let i = 1; i < this.pathParameterSegregator.length; i++) {
        this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
        this.pathParameterSegregator[i] = this.pathParameterStopper[0];
      }
      const temp2 = querySeparator[0].split('/');
      this.pathParameter = [];
      for (let i = 1; i < this.pathParameterSegregator.length; i++) {
        this.pathParameterValue = this.pathParameterSegregator[i];
        this.find = true;
        for (let j = 0; j < this.pathParameter.length; j++) {
          if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
            this.find = false;
          }
        }
        if (this.find === true) {
          if (this.pathParameterValue[0] !== '{' && this.pathParameterValue !== '') {
            this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
          }
        }
      }
      for (let i = 0; i < temp2.length; i++) {
        if (temp2[i]) {
          const temp = temp2[i].split('{');
          for (let segment of temp) {
            if (segment) {
              segment = '{' + segment;
            }
            const init = segment.indexOf('{');
            const fin = segment.indexOf('}');
            if ((!(this.pathParameter.some(e => e.key === segment.substr(init + 1, fin - init - 1))) && segment.substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
              this.pathParameter.push({'key': segment.substr(init + 1, fin - init - 1), 'value': '', 'description': ''});
            }
          }
        }
      }
      if (this.pathParameter.length !== 0) {
        this.showPathParameters = true;
      } else {
        this.showPathParameters = false;
      }
    }
  }

  getDataModel() {
    this.dataModel = {};
    const that = this;
    this.dataSource.forEach((data) => {
      if (data && data != null && data !== undefined) {
        if (data.type !== 'Array') {
          this.dataModel[data.attributeName] = data.type;
        } else {
          this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
        }
      }
    });
    this.dataModelPut = this.dataModel;
    this.dataModelPost = this.dataModel;
    return this.dataModel;
  }

  getBackgroundStyle(val) {
    if (val === 'GET') {
      return 'get-method';
    } else if (val === 'PUT') {
      return 'put-method';
    } else if (val === 'POST') {
      return 'post-method';
    } else if (val === 'DELETE') {
      return 'delete-method';
    } else {
      return 'get-method';
    }
  }

  getStatusCodeStyle(val) {
    if (val < 400) {
      return 'status-ok';
    } else {
      return 'status-not-ok';
    }
  }

  deleteRecord(version, id: string, event) {
    if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
      this._service.deleteItem(id, version, this.partner, this.account, this.entity).subscribe(
          agents => {
            this.platform.openSnackBar('Deleted successfully', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            const itemDuplicate = this.items;
            const deleteditem = itemDuplicate.findIndex(p => p.id === id);
            delete this.items[deleteditem];
            //  this.removeItemFromUI(event);
          },
          error => {
            this.platform.openSnackBar('Error while deleting this record' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
      );
    } else {
    }
  }

  toggleExecutor(ev) {
    $('.executor-definition').slideToggle();
    $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
  }

  typeOfval(val) {
    return typeof val;
  }

  getSub(data) {
    const subType = [];
    const obj = {};
    const that = this;
    if (data.length > 0) {
      data.forEach((result) => {
        if (result.type !== 'Array') {
          obj[result.attributeName] = result.type;
        } else {
          obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
        }
      });
      subType.push(obj);
    }
    return subType;
  }

  saveApi() {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_register_apiplatform_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.devexListenerInstance.devexListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    if (this.MyForm1.valid && this.MyForm2.valid) {
      this.isCountOfResAtt = false;
      if (this.apiByDefinition.length >= 1 && this.apiByDefinition[0]['attributeName'] !== null) {
        this.isCountOfResAtt = true;
      }
      if (this.authModel1) {
        this.openDeployAsApiDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel1.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, false);
      } else {
        this.openDeployAsApiDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, false);
      }
    } else {
      this.platform.openSnackBar('API URL is required', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }

  }

  registerApi() {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_register_asis_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.devexListenerInstance.devexListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    if (this.MyForm1.valid && this.MyForm2.valid) {
      this.isCountOfResAtt = false;
      this.partner = this.accountInfoService.partner;
      this.account = this.accountInfoService.account;
      if (this.apiByDefinition.length >= 1 && this.apiByDefinition[0]['attributeName'] !== null) {
        this.isCountOfResAtt = true;
      }
      if (this.authModel1) {
        this.registerApiThruDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel1.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, false);
      } else {
        this.registerApiThruDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, false);
      }
    } else {
      this.platform.openSnackBar('API URL is required', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  updateThirdPartyApiUrl() {

    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    this.kongService.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.executor_name + '-' + this.executor_version).subscribe(service => {
      loaderDialog.close();
      const gatewayService = service;
      let apiUrl = '';

      if (gatewayService['protocol']) {
        if (gatewayService['protocol'] === 'https') {
          apiUrl = gatewayService['protocol'] + '://' + gatewayService['host'] + gatewayService['path'];
        } else {
          apiUrl = gatewayService['protocol'] + '://' + gatewayService['host'] + ':' + gatewayService['port'] + gatewayService['path'];
        }
      }

      if (apiUrl !== '') {
        const dialogRef = this.dialog.open(DefaultApiUrlComponent, {
          width: '60%',
          data: {
            gatewayUrl: this.httpUrl,
            apiUrl: apiUrl
          }
        });

        dialogRef.afterClosed().subscribe(async newUrl => {
          if (newUrl) {
            const str = newUrl.slice(newUrl.indexOf('://') + 3);
            const proto = newUrl.substring(0, newUrl.indexOf(':'));
            let port = 80;
            let dataroot = '';
            let host = '';
            if (str.search(':') === -1) {
              if (proto === 'https') {
                port = 443;
                host = str.substring(0, str.indexOf('/'));
                dataroot = str.substring(str.indexOf(host) + host.length, str.length);
              } else {
                host = str.substring(0, str.indexOf('/'));
                dataroot = str.substring(str.indexOf(host) + host.length, str.length);
              }
            } else {
              port = +str.substring(str.indexOf(':') + 1, str.indexOf('/'));
              host = host = str.substring(0, str.indexOf(':'));
              dataroot = str.substring(str.indexOf('/'), str.length);

            }
            const temp = dataroot.split('?');
            dataroot = temp[0];

            gatewayService['protocol'] = proto;
            gatewayService['host'] = host;
            gatewayService['port'] = port;
            gatewayService['path'] = dataroot;

            const servicePayload = {
              name: gatewayService['name'],
              protocol: gatewayService['protocol'],
              host: gatewayService['host'],
              port: gatewayService['port'],
              path: gatewayService['path'],
              retries: gatewayService['retries'],
              connect_timeout: gatewayService['connect_timeout'],
              read_timeout: gatewayService['read_timeout'],
              write_timeout: gatewayService['write_timeout'],
            };
            if (gatewayService['client_certificate'] !== null && gatewayService['client_certificate'] !== undefined && gatewayService['client_certificate'] !== '') {
              service['client_certificate'] = {id: gatewayService['client_certificate']};
            }

            const loaderDialog2 = this.dialog.open(LoaderWithProgressComponent, {
              maxWidth: '95vw',
              maxHeight: '60vh',
            });
            this.kongService.updateServiceInApiGateway(gatewayService['name'], servicePayload).subscribe(data => {
              loaderDialog2.close();
              this.platform.openSnackBar('Upstream API URL updated successfully.', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }, error => {
              loaderDialog2.close();
              this.platform.handleErrorGracefully(error, 'Error while updating the service in API Gateway. Please try after sometime.');
            });
          }
        });
      } else {
        this.platform.openSnackBar('Unable to retrieve Upstream API URL. Please contact adminstrator.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }, error => {
      loaderDialog.close();
      this.platform.openSnackBar('Error while retrieving Upstream API URL. Please try again later.', 'Error', {
        duration: 7000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  updateApiDefinition() {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_tester_update_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.devexListenerInstance.devexListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    this.isCountOfResAtt = false;
    if (this.apiByDefinition.length >= 1 && this.apiByDefinition[0]['attributeName'] !== null) {
      this.isCountOfResAtt = true;
    }
    this.isUpdating = true;

    if (this.executor && this.executor['executor_type'] === 'THIRDPARTY') {

      if (this.executor['registeredAsIs'] === true) {
        if (this.authModel1) {
          this.registerApiThruDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel1.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, true);
        } else {
          this.registerApiThruDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, true);
        }
      } else {
        if (this.orig_executor['apiUrl'] === this.httpUrl) {
          if (this.authModel1) {
            this.openDeployAsApiDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel1.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, true);
          } else {
            this.openDeployAsApiDialog(this.partner, this.account, this.httpUrl, this.httpOperation, this.authModel, this.headers, this.queryParams, this.pathParams, this.requestBody, this.prerequisites, this.apiByDefinition, this.isCountOfResAtt, true);
          }
        } else {
          this.isUpdating = false;
          this.platform.openSnackBar('API URL cannot be changed.', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    } else {
      if (this.executor) {
        this.updateExecutor(this.partner, this.account, this.httpUrl, this.httpOperation, this.executor['authModel'], this.executor['headers'], this.executor['queryParams'], this.executor['pathParams'], this.executor['requestBody']);
      }
    }
  }

  updateExecutor(partner, account, apiUrl, methodType, authModel, headers, queryParams, pathParams, requestBody) {

    if (this.orig_executor['apiUrl'] === apiUrl) {
      if (this.orig_executor['executor_method_type'] === methodType) {
        const executorPayload = JSON.parse(JSON.stringify(this.orig_executor));

        if (queryParams) {
          for (let i = queryParams.length - 1; i >= 0; i--) {
            if (queryParams[i]) {
              if (queryParams[i]['key'] === '' && queryParams[i]['value'] === '') {
                queryParams.splice(i, 1);
              }
            }
          }
        }

        if (headers) {
          for (let i = headers.length - 1; i >= 0; i--) {
            if (headers[i]) {
              if (headers[i]['key'] === '' && headers[i]['value'] === '') {
                headers.splice(i, 1);
              }
            }
          }
        }
        const apiExecutorData = {};
        if (this.orig_executor) {
          apiExecutorData['executor_type'] = this.orig_executor.executor_type;
          apiExecutorData['executor_name'] = this.orig_executor.executor_name;
          apiExecutorData['executor_version'] = this.orig_executor.executor_version;
          apiExecutorData['executor_display_name'] = this.orig_executor.executor_display_name;
          apiExecutorData['executor_description'] = this.orig_executor.executor_description;
          apiExecutorData['executor_category'] = this.orig_executor.executor_category;
          apiExecutorData['executor_category_group'] = this.orig_executor.executor_category_group;
          apiExecutorData['executor_scope'] = this.orig_executor.scopeOfAccess;
          apiExecutorData['registeredAsIs'] = this.executor.registeredAsIs;
          if (!this.orig_executor.scopeOfAccess) {
            apiExecutorData['executor_scope'] = this.orig_executor.executor_scope;
          }
          if (this.orig_executor.hasOwnProperty('service_provider')) {
            apiExecutorData['service_provider'] = this.orig_executor.service_provider;
          }
        }

        executorPayload['headers'] = headers;
        executorPayload['queryParams'] = queryParams;
        executorPayload['authModel'] = authModel;
        executorPayload['pathParams'] = pathParams;
        executorPayload['requestBody'] = requestBody;
        executorPayload['lastModifiedTime'] = Date.now();
        executorPayload['mockResponses'] = this.platform.validateMockResponseData(this.mockResponses);
        this.setDevexPropertiesIntoModel(executorPayload);

        const dialogRef = this.dialog.open(DeployAsApiComponent, {
          width: '60%',
          data: apiExecutorData
        });


        dialogRef.afterClosed().subscribe(async result => {
          if (result) {
            if (dialogRef.componentInstance.executor_category && dialogRef.componentInstance.executor_category.length > 0) {
              executorPayload['executor_display_name'] = dialogRef.componentInstance.executor_display_name;
              executorPayload['executor_description'] = dialogRef.componentInstance.executor_description;
              executorPayload['executor_category'] = dialogRef.componentInstance.executor_category;
              executorPayload['executor_category_group'] = dialogRef.componentInstance.executor_category_group;
              executorPayload['service_provider'] = dialogRef.componentInstance.service_provider;

              const execId = executorPayload['id'];
              const updatedOrigExecutor = JSON.parse(JSON.stringify(executorPayload));
              delete executorPayload['id'];

              if (this.orig_executor['scopeOfAccess'] !== dialogRef.componentInstance.executor_scope && executorPayload['executor_type'] !== 'API') {
                Promise.resolve(this.accessPolicyService.togglePublicAccess(partner, account, executorPayload['executor_name'], executorPayload['executor_version'], updatedOrigExecutor)).then(response => {
                  if (response !== 'cancel') {
                    this.isUpdating = false;
                    this.platform.openSnackBar('Updated the API successfully', 'Success', {
                      duration: 5000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                    this.orig_executor = JSON.parse(JSON.stringify(updatedOrigExecutor));
                  } else {
                    this.isUpdating = false;
                  }
                }, error => {
                  this.isUpdating = false;
                  this.platform.handleErrorGracefully(error, 'Error while updating the API : ' + executorPayload.executor_name + '(' + executorPayload.executor_version + ')');
                });
              } else {
                this.confPost.updateApiExecutorForPartnerAccount(partner, account, execId, executorPayload).subscribe(async data => {
                  this.orig_executor = JSON.parse(JSON.stringify(updatedOrigExecutor));
                  this.isUpdating = false;
                  this.platform.openSnackBar('Updated the API successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                }, error => {
                  this.isUpdating = false;
                  this.platform.openSnackBar('Error while updating the API : ' + executorPayload.executor_name + '(' + executorPayload.executor_version + ')', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                });
              }
            } else {
              this.isUpdating = false;
              this.platform.openSnackBar('Enter a valid category', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }

          } else {
            this.isUpdating = false;
          }
        });
      } else {
        this.isUpdating = false;
        this.platform.openSnackBar('Method type cannot be changed.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.isUpdating = false;
      this.platform.openSnackBar('API URL cannot be changed.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  setDevexPropertiesIntoModel(model) {
    if (!model['properties']) {
      model['properties'] = {};
    }
    model['properties']['showBodyParamDescription'] = this.devexHeader.isBodyParamDescriptionEnabled();
    model['properties']['bodyParamDescription'] = this.devexHeader.getBodyParamDescription();
  }

  download() {
    $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
    this.saveAsProject();
  }

  saveAsProject() {
    // you can enter your own file name and extension
    if (this.responseType === 'json') {
      const data = this.responseData;
      const fileName = 'download';
      const exportType = 'json';
      exportFromJSON({data, fileName, exportType});
    } else if (this.responseType === 'text') {
      this.writeContents(this.responseText, 'Sample File' + '.txt', 'text/plain');
    } else {
      alert('We do not support the export of ' + this.responseText + '.');
    }
  }

  writeContents(content, fileName, contentType) {
    const a = document.createElement('a');
    const file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  //
  // addParameter() {
  //   const pushData = {
  //     'key': '',
  //     'value': '',
  //     'description': ''
  //   };
  //   this.parameterData.push(pushData);
  // }

  // removeParameter(index) {
  //   // delete this.parameterData[index];
  //   this.parameterData.splice(index, 1);
  // }

  // addHeader() {
  //   const pushData = {
  //     'key': '',
  //     'value': '',
  //     'description': ''
  //   };
  //   this.headersData.push(pushData);
  // }

  // removeHeader(index) {
  //   // delete this.headersData[index];
  //   this.headersData.splice(index, 1);
  // }

  // addFormData() {
  //   const pushData = {
  //     'key': '',
  //     'value': '',
  //     'description': ''
  //   };
  //   this.formData.push(pushData);
  // }


  // getDevExItemsForCustomExecutor() {
  //   this.orig_executor = JSON.parse(JSON.stringify(this.executor));
  //   if (this.executor) {
  //     this.httpUrl = this.executor.apiUrl;
  //     this.executor_name = this.executor.executor_name;
  //     this.executor_version = this.executor.executor_version;
  //     this.executor_type = this.executor.executor_type;
  //     this.executor_method_type = this.executor.executor_method_type;
  //     this.httpOperation = this.executor.executor_method_type;
  //     this.parameterData = this.executor.queryParams;
  //     this.pathParameter = this.executor.pathParams;
  //     this.authModel = this.executor.authModel;
  //     this.headersData = this.executor.headers;
  //     for (const header of this.headersData) {
  //       if (header['key'] === 'Content-Type') {
  //         switch (header['value']) {
  //           case 'multipart/form-data':
  //             this.requestBodySelected = 'form-data';
  //             this.formData = this.executor.requestBody.value;
  //             this.formDataTrue = true;
  //             this.formURLEncodedTrue = false;
  //             break;
  //           case 'application/x-www-form-urlencoded':
  //             this.requestBodySelected = 'x-www-form-urlencoded';
  //             this.formData = this.executor.requestBody.value;
  //             this.formDataTrue = false;
  //             this.formURLEncodedTrue = true;
  //             break;
  //           case 'application/json':
  //             this.requestBodySelected = 'raw';
  //             this.rawRequestBody = this.executor.requestBody.value;
  //             break;
  //           default:
  //             this.requestBodySelected = 'none';
  //             break;
  //         }
  //       }
  //     }
  //     this.requestBody = this.executor.requestBody;
  //     this.executors = this.executor.executors;
  //     if (this.executor.responseAttributes !== null) {
  //       this.apiByDefinition = this.executor.responseAttributes;
  //     }
  //     this.mockResponses = this.executor.mockResponses ? this.executor.mockResponses : [];
  //     this.devexgeneric = true;
  //     this.updateTabName(this.httpOperation, this.httpUrl);
  //     this.bodyParamDescription = this.executor['properties'] ? this.executor['properties']['bodyParamDescription'] ? this.executor['properties']['bodyParamDescription'] : [] : [];
  //     this.isBodyParamEnabled = this.executor['properties'] ? this.executor['properties']['showBodyParamDescription'] ? this.executor['properties']['showBodyParamDescription'] : false : false;
  //
  //   }
  //   this.resetResponseAttributes();
  // }


  // getDevExItems() {
  //   this.confPost.getPartnerEntity(this.account, this.entity, this.partner).subscribe(items => {
  //     if (items && items !== null && items !== undefined) {
  //       this.dataSource = items[0].attributes;
  //       this.getDataModel();
  //     } else {
  //       this.platform.openSnackBar('Error while fetching the API. Please try again after sometime.', 'Error', {
  //         duration: 3000,
  //         verticalPosition: 'top',
  //         horizontalPosition: 'center'
  //       });
  //       setTimeout(() => {
  //         this.router.navigateByUrl('/controlplane');
  //       }, 2000);
  //     }
  //   }, error => {
  //     this.platform.openSnackBar('Error while fetching the API. Please try again after sometime.', 'Error', {
  //       duration: 3000,
  //       verticalPosition: 'top',
  //       horizontalPosition: 'center'
  //     });
  //     setTimeout(() => {
  //       this.router.navigateByUrl('/controlplane');
  //     }, 2000);
  //   });
  //   this.error = false;
  //   this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(
  //       items => {
  //         if (items && items !== null && items !== undefined) {
  //           this.items = items;
  //           this.attributes = this.items.attributes;
  //           this.operations = this.items.operations;
  //           this.getRequest = null;
  //           this.getResponse = null;
  //           this.putRequest = null;
  //           this.putResponse = null;
  //           this.postRequest = null;
  //           this.postResponse = null;
  //           this.deleteRequest = null;
  //           this.deleteResponse = null;
  //
  //           this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.partner, this.account, this.entity, this.version).subscribe(
  //               executors => {
  //                 this.operations1 = executors;
  //                 for (const executor of this.operations1) {
  //                   if (executor['authModel'] === null || executor['authModel'] === undefined || executor['authModel'] === '' || executor['authModel'] === {}) {
  //                     executor['authModel'] = this.authModel;
  //                     executor['authModel']['authType'] = '';
  //                   }
  //                 }
  //                 this.sourceOperations1 = executors;
  //               }, error => {
  //                 this.platform.openSnackBar('Error while fetching operations for this API. Please try again after sometime.', 'Error', {
  //                   duration: 2000,
  //                   verticalPosition: 'top',
  //                   horizontalPosition: 'center'
  //                 });
  //                 setTimeout(() => {
  //                   this.router.navigateByUrl('/controlplane');
  //                 }, 2000);
  //               });
  //         } else {
  //           this.platform.openSnackBar('Error while fetching the API. Please try again after sometime.', 'Error', {
  //             duration: 3000,
  //             verticalPosition: 'top',
  //             horizontalPosition: 'center'
  //           });
  //           setTimeout(() => {
  //             this.router.navigateByUrl('/controlplane');
  //           }, 2000);
  //         }
  //       },
  //       error => {
  //         this.error = true;
  //         this.errorMessage = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '';
  //         this.router.navigateByUrl('/controlplane');
  //       }
  //   );
  // }

  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }

  // attachContentType(type) {
  //   let contentTypeExists: boolean;
  //   for (const header of this.headersData) {
  //     if (header) {
  //       if (header['key'] === 'Content-Type') {
  //         header['value'] = type;
  //         contentTypeExists = true;
  //       }
  //     }
  //   }
  //   if (contentTypeExists !== true) {
  //     this.headersData.push({'key': 'Content-Type', 'value': type, 'description': ''});
  //   }
  // }

  getRequestBody() {
    if (this.requestBodySelected === 'raw') {
      const requestbody = {
        'value': this.getRequestBodyValue(this.requestBodySelected),
        'key': 'payload',
        'description': 'Document in JSON format',
        'annotation': 'RequestBody'
      };
      return requestbody;
    } else if (this.requestBodySelected === 'form-data') {
      const requestbody = {
        'value': this.formData,
        'key': 'payload',
        'description': 'Document in JSON format',
        'annotation': 'RequestBody'
      };
      return requestbody;
    } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
      const requestbody = {
        'value': this.formData,
        'key': 'payload',
        'description': 'Document in JSON format',
        'annotation': 'RequestBody'
      };
      return requestbody;
    } else if (this.requestBodySelected === 'none') {
      const requestbody = null;
      return requestbody;
    }
  }

  getRequestBodyValue(val) {
    switch (val) {
      case 'raw':
        return this.editor.get();
      case 'binary':
      case 'none':
      default:
    }
  }

  saveDescription(attr, value) {
    attr.description = value;
  }

  publishDocs() {

    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_documentation_publish_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.devexListenerInstance.devexListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });

    let isError = false;
    this.loading = true;

    if (this.items) {
      this.confPost.updateEntity(this.partner, this.account, this.items).subscribe(result => {
      }, error => {
        isError = true;
      });
    }

    if (!this.businesslogic) {
      if (this.operations1) {
        for (let i = 0; i < this.operations1.length; i++) {
          if (this.operations1[i]) {
            this.sourceOperations1[i]['executor_description'] = this.operations1[i]['executor_description'];
            if (this.operations1[i].queryParams) {
              for (let j = 0; j < this.operations1[i].queryParams.length; j++) {
                if (this.operations1[i].queryParams[j]) {
                  this.sourceOperations1[i].queryParams[j]['description'] = this.operations1[i].queryParams[j]['description'];
                }
              }
            }

            if (this.operations1[i].pathParams) {
              for (let j = 0; j < this.operations1[i].pathParams.length; j++) {
                if (this.operations1[i].pathParams[j]) {
                  this.sourceOperations1[i].pathParams[j]['description'] = this.operations1[i].pathParams[j]['description'];
                }
              }
            }

            if (this.operations1[i].headers) {
              for (let j = 0; j < this.operations1[i].headers.length; j++) {
                if (this.operations1[i].headers[j]) {
                  this.sourceOperations1[i].headers[j]['description'] = this.operations1[i].headers[j]['description'];
                }
              }
            }

            if (this.operations1[i].requestBody) {
              this.sourceOperations1[i].requestBody['description'] = this.operations1[i].requestBody['description'];
            }
          }
        }

        for (const operation of this.sourceOperations1) {
          if (operation['edit_executor_display_name']) {
            delete operation['edit_executor_display_name'];
          }
          this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account, operation['id'], operation).subscribe(result => {

          }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_documentation_publish_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), this.operations1, error, this.router.url)).then(resp => {
              const payloadToSend = {
                actions: resp
              };
              this.devexListenerInstance.devexListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
              });
            });
            isError = true;
          });
        }
      }
    } else {
      if (this.executor && this.sourceExecutor) {
        this.sourceExecutor['executor_description'] = this.executor['executor_description'];
        if (this.executor.queryParams) {
          for (let i = 0; i < this.executor.queryParams.length; i++) {
            if (this.executor.queryParams[i]) {
              this.sourceExecutor.queryParams[i]['description'] = this.executor.queryParams[i]['description'];
            }
          }
        }
        if (this.executor.pathParams) {
          for (let i = 0; i < this.executor.pathParams.length; i++) {
            if (this.executor.pathParams[i]) {
              this.sourceExecutor.pathParams[i]['description'] = this.executor.pathParams[i]['description'];
            }
          }
        }
        if (this.executor.headers) {
          for (let i = 0; i < this.executor.headers.length; i++) {
            if (this.executor.headers[i]) {
              this.sourceExecutor.headers[i]['description'] = this.executor.headers[i]['description'];
            }
          }
        }
        if (this.executor.requestBody) {
          this.sourceExecutor.requestBody['description'] = this.executor.requestBody['description'];
        }

        if (this.sourceExecutor['edit_executor_display_name']) {
          delete this.sourceExecutor['edit_executor_display_name'];
        }
        this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account, this.sourceExecutor['id'], this.sourceExecutor).subscribe(result => {

        }, error => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_documentation_publish_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), this.executor, error, this.router.url)).then(resp => {
            const payloadToSend = {
              actions: resp
            };
            this.devexListenerInstance.devexListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          isError = true;
        });
      }
    }

    if (!isError) {
      const payload = this.businesslogic ? this.executor : this.operations1;

      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_documentation_publish_success', 'INFO', 200, 'OK', '', payload, '', this.router.url)).then(resp => {
        const payloadToSend = {
          actions: resp
        };
        this.devexListenerInstance.devexListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });

      this.platform.openSnackBar('Documentation saved successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.loading = false;
    } else {
      this.platform.openSnackBar('Error in publishing', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.loading = false;
    }
  }

  // resetResponseAttributes() {
  //   this.responses = '';
  //   this.responseItems = '';
  //   this.responseData = '';
  //   this.errorMessage = '';
  //   this.responseError = '';
  //   this.responseCookies = '';
  //   this.responseHeaders = '';
  //   this.responseError = '';
  //   this.responseCode = '';
  //   this.responseTime = '';
  // }

  async executeApi() {
    this.returnType = '';
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_tester_execute_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
      const payloadToSend = {
        actions: response1
      };
      this.devexListenerInstance.devexListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    this.itemList = [];
    if (this.httpOperation && this.httpOperation !== '' && this.httpUrl && this.httpUrl !== '') {
      if (this.httpUrl.includes(' ')) {
        this.platform.openSnackBar('URL should not contain spaces', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else {
        this.executeFlag = true;
        this.responseCode = '';
        this.responseTime = '';
        this.responseData = '';
        this.errorMessage = '';
        this.responseError = '';
        this.responseText = '';
        this.apiByDefinition = [];
        this.showResponseSection = true;

        const urlSplitByQueryParams = this.httpUrl.split('?');

        if (this.parameterData) {
          for (let i = this.parameterData.length - 1; i >= 0; i--) {
            if (this.parameterData[i]) {
              if (this.parameterData[i]['key'] === '' && this.parameterData[i]['value'] === '') {
                this.parameterData.splice(i, 1);
              }
            }
          }
        }

        if (this.headersData) {
          for (let i = this.headersData.length - 1; i >= 0; i--) {
            if (this.headersData[i]) {
              if (this.headersData[i]['key'] === '' && this.headersData[i]['value'] === '') {
                this.headersData.splice(i, 1);
              }
            }
          }
          if (localStorage.getItem('isCookieEnabled') === 'true' && localStorage.getItem('isCookieEnabled') !== null) {
            const api_url = (new URL(urlSplitByQueryParams[0]));
            const domain = api_url.hostname;
            const cookie = this.cookieService.get(domain);
            let cookieValue = [];
            if (cookie !== '') {
              const cookieList = cookie.split('___');
              const recentCookie = cookieList.reduce(
                  function (a, b) {
                    return a.length > b.length ? a : b;
                  }
              );
              cookieValue = recentCookie.split(' ');
            }
            if (cookieValue.length > 0 && cookieValue[0] !== '') {
              this.headersData[0]['Cookie'] = cookieValue[0];
            }
          }
          if (this.headersData && this.headersData !== undefined && this.headersData !== null && this.headersData.length > 0 && this.headersData[0].hasOwnProperty('Cookie') && localStorage.getItem('isCookieEnabled') === 'null') {
            delete this.headersData[0]['Cookie'];
          }
        }

        const payload = {
          'partner': this.partner,
          'account_id': this.account,
          'executor_name': this.executor_name,
          'executor_type': this.executor_type !== null ? this.executor_type : 'API',
          'executor_version': this.executor_version,
          'executor_method_type': this.httpOperation,
          'apiUrl': urlSplitByQueryParams[0],
          'dataroot': null,
          'queryParams': this.parameterData,
          'pathParams': this.pathParameter,
          'headers': this.headersData,
          'requestBody': await this.headerChild.getRequestBody(),
          'executors': this.executors,
          'prerequisites': null
        };
        payload['authModel'] = this.headerChild.authModel1.getAuthModel();
        const startTime = performance.now();
        this._service.executeApi(payload).subscribe(response2 => {
              const mockResponse = {
                statusCode: 0,
                methodType: this.httpOperation,
                headers: [],
                message: null,
                description: null,
                sampleData: null,
                responseAttributes: [],
              };
              Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_tester_execute_success', 'INFO', response2.status, response2.statusText, '', payload, '', this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              const endTime = performance.now();
              this.responses = response2;
              this.responseItems = this.responses.body;
              if (this.responseItems && this.responseItems.attributes) {
                for (let i = 0; i < this.responseItems.attributes.length; i++) {
                  this.itemList.push({id: i, itemName: this.responseItems.attributes[i].attributeName});
                }
                for (const attribute of this.responseItems.attributes) {
                  if (attribute['attributeName'].includes('$.result.')) {
                    attribute['attributeName'] = attribute['attributeName'].replace('$.result.', '');
                  }
                }
                this.apiByDefinition = this.responseItems.attributes;

              }
              if (this.responseItems && this.responseItems.statusCode) {
                this.responseCode = this.responseItems.statusCode;
              }
              if (this.responseCode && this.responseCode >= 400) {
                this.error = true;
              } else {
                this.error = false;
              }
              if (this.error) {
                if (this.responseItems && this.responseItems.body && this.responseItems.body['message']) {
                  this.responseData = JSON.parse(JSON.stringify(this.responseItems.body));
                  this.errorMessage = this.responseData['message'];
                  this.responseError = this.responseData['error'];
                } else if (!this.responseItems.body['message'] && this.responseItems && this.responseItems.body) {
                  this.responseData = JSON.parse(JSON.stringify(this.responseItems.body));
                  if (this.responseData.hasOwnProperty('error')) {
                    this.errorMessage = this.responseData['error']['message'];
                  } else {
                    this.errorMessage = this.responseItems.body;
                  }
                } else {
                  this.errorMessage = this.getErrorMessage(this.responseCode); // this.responseItems.message;
                  if (this.responseItems.error) {
                    this.responseError = this.responseItems.error;
                  }
                }
              }
              if (this.responseItems && this.responseItems.headers) {
                this.responseHeaders = this.responseItems.headers;
              }
              mockResponse.statusCode = parseInt(this.responseCode);
              mockResponse.responseAttributes = JSON.parse(JSON.stringify(this.apiByDefinition));
              mockResponse.headers = this.responseHeaders;

              const index = this.mockResponses.findIndex(value => value['statusCode'] === mockResponse['statusCode']);

              if (index === -1) {
                this.mockResponses.push(mockResponse);
              } else {
                this.mockResponses.splice(index, 1, mockResponse);
              }
              if (this.responseHeaders && this.responseHeaders.length > 0) {
                const contentType = this.responseHeaders.filter(element => element.name.toLowerCase() === 'content-type');
                if (contentType && contentType.length > 0 && contentType[0]['name'] === 'content-type') {
                  if (contentType[0]['value'].includes('json')) {
                    this.responseType = 'json';
                    this.userView = 'json';
                  } else if (contentType[0]['value'].includes('html')) {
                    this.responseType = 'html';
                    this.userView = 'html';
                  } else if (contentType[0]['value'].includes('text')) {
                    this.responseType = 'text';
                    this.userView = 'text';
                  } else if (contentType[0]['value'].includes('xml')) {
                    this.responseType = 'xml';
                    this.userView = 'xml';
                  } else {
                    this.platform.openSnackBar('We do not support the response type you are trying to view.', 'Info', {
                      duration: 2000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                    this.responseType = 'json';
                  }
                }
                if (this.responseType === '' || this.responseType === undefined || this.responseType === null) {
                  this.responseType = 'json';
                }
                if (this.responseHeaders && this.responseHeaders.length > 0 && this.responseItems && this.responseItems.body) {
                  const contentType = this.responseHeaders.filter(element => element.name.toLowerCase() === 'content-type');
                  const setCookie = this.responseHeaders.filter(element => element.name.toLowerCase() === 'set-cookie');
                  const api_url = (new URL(payload['apiUrl']));
                  const domain = api_url.hostname;
                  let cookie = '';
                  for (let i = 0; i < setCookie.length; i++) {
                    const value = setCookie[i].value;
                    cookie = cookie + value;
                    if (i < setCookie.length - 1) {
                      cookie = cookie + '___';
                    }
                  }
                  this.cookieService.set(domain, cookie);
                  if (contentType && contentType.length > 0 && contentType[0]['name'].toLowerCase() === 'content-type') {
                    if (contentType[0]['value'].includes('application/json')) {
                      this.responseType = 'json';
                      this.userView = 'json';
                      if (this.responseItems.body.startsWith('[{')) {
                        this.returnType = 'Array';
                        this.responseData = JSON.parse(this.responseItems.body);
                        this.jsonViewer = this.stringifyjson(this.responseData);
                      } else if (this.responseItems.body.startsWith('{')) {
                        this.returnType = 'JSON Object';
                        this.responseData = [];
                        this.responseData.push(JSON.parse(this.responseItems.body));
                        this.jsonViewer = this.stringifyjson(this.responseData[0]);
                      } else if (this.responseItems.body.startsWith('[')) {
                        this.returnType = 'Array';
                        this.responseData = JSON.parse(this.responseItems.body);
                        this.jsonViewer = this.stringifyjson(this.responseData);
                      }
                    } else if (contentType[0]['value'].includes('application/xml') || contentType[0]['value'].includes('text/xml')) {
                      if (contentType[0]['value'].includes('application/xml')) {
                        this.responseType = 'xml';
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(this.responseItems.body, 'application/xml');
                        this.responseText = this.prettifyXml(xmlDoc);
                        this.returnType = 'XML';
                        this.userView = 'xml';
                      } else if (contentType[0]['value'].includes('text/xml')) {
                        this.responseType = 'xml';
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(this.responseItems.body, 'text/xml');
                        this.responseText = this.prettifyXml(xmlDoc);
                        this.returnType = 'XML';
                        this.userView = 'xml';
                      } else {
                        this.responseType = 'text';
                        this.returnType = 'Text';
                        this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
                        this.userView = 'text';
                      }
                    } else if (contentType[0]['value'].includes('text/html')) {
                      this.responseType = 'html';
                      this.responseText = this.responseItems.body;
                      this.returnType = 'HTML';
                      this.userView = 'html';
                    } else {
                      this.responseType = 'text';
                      this.returnType = 'Text';
                      this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
                      this.userView = 'text';
                    }
                  } else {
                    this.responseType = 'text';
                    this.returnType = 'Text';
                    this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
                    this.userView = 'text';
                  }
                }

              } else {
                this.responseType = 'text';
                this.returnType = 'Text';
                this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
                this.userView = 'text';
              }
              this.responseTime = Math.round(endTime - startTime);
              this.executeFlag = false;
            },
            error => {
              Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_tester_execute_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), payload, error, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              if (error.error.message) {
                if (error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1)) {
                  this.responseObject = JSON.parse(error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1));
                  this.responseCode = this.responseObject.status;
                  this.errorMessage = this.responseObject.message;
                  this.responseError = this.responseObject.error;
                  this.responseTimestamp = this.responseObject.timestamp;
                } else {
                  this.responseCode = error.error.status;
                  this.errorMessage = error.error.message;
                  this.responseError = 'Internal Server Error';
                }
              } else if (error.error.body) {
                if (error.error.body.startsWith('{')) {
                  this.errorMessage = JSON.parse(error.error.body);
                } else {
                  this.responseCode = error.status;
                  this.errorMessage = error.error.body;
                }
              } else {
                this.responseCode = 500;
                this.errorMessage = 'Error while processing your request. Please check the headers and query parameters that may be missing in your request.';
                this.responseError = 'Internal Server Error';
              }
              this.error = true;
              this.executeFlag = false;
            }
        );
      }
    } else {
      this.platform.openSnackBar('API URL is required', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  prettifyXml(xmlDoc) {
    const xsltDoc = new DOMParser().parseFromString([
      '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
      '  <xsl:strip-space elements="*"/>',
      '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
      '    <xsl:value-of select="normalize-space(.)"/>',
      '  </xsl:template>',
      '  <xsl:template match="node()|@*">',
      '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
      '  </xsl:template>',
      '  <xsl:output indent="yes"/>',
      '</xsl:stylesheet>',
    ].join('\n'), 'application/xml');

    const xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    const resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
  }

  getErrorMessage(errorCode) {
    switch (errorCode) {
      case 400:
        return 'Bad Request';
      case 401:
        return 'Unauthorized';
      case 402:
        return 'Payment Required';
      case 403:
        return 'Forbidden';
      case 404:
        return 'Not Found';
      case 405:
        return 'Method Not Allowed';
      case 406:
        return 'Not Acceptable';
      case 407:
        return 'Proxy Authentication Required';
      case 408:
        return 'Request Timeout';
      case 409:
        return 'Conflict';
      case 410:
        return 'Gone';
      case 411:
        return 'Length Required';
      case 412:
        return 'Precondition Failed';
      case 413:
        return 'Payload Too Large';
      case 414:
        return 'URI Too Long';
      case 415:
        return 'Unsupported Media Type';
      case 416:
        return 'Range Not Satisfiable';
      case 417:
        return 'Expectation Failed';
      case 418:
        return 'I am a teapot';

    }
  }

  openDeployAsApiDialog(partner, account, apiUrl, methodType, authModel, headers, queryParams, pathParams, requestBody, prerequisites, responseAttributes, isCountOfResAtt, updateExecutor): void {
    const apiExecutorData = {};
    const timeStamp = Date.now();
    this.executor_url = apiUrl;
    apiExecutorData['partner'] = partner;
    apiExecutorData['account'] = account;
    apiExecutorData['apiUrl'] = apiUrl;
    apiExecutorData['authModel'] = authModel;
    apiExecutorData['headers'] = headers;
    apiExecutorData['queryParams'] = queryParams;
    apiExecutorData['pathParams'] = pathParams;
    apiExecutorData['requestBody'] = requestBody;
    apiExecutorData['prerequisites'] = prerequisites;
    apiExecutorData['responseAttributes'] = responseAttributes;
    apiExecutorData['executor_method_type'] = methodType;
    apiExecutorData['isCountOfResAtt'] = isCountOfResAtt;
    apiExecutorData['executor_scope'] = 'public';
    apiExecutorData['executor_type'] = 'THIRDPARTY';
    apiExecutorData['registeredAsIs'] = false;
    apiExecutorData['mockResponses'] = this.platform.validateMockResponseData(this.mockResponses);
    this.setDevexPropertiesIntoModel(apiExecutorData);

    if (this.executor) {
      apiExecutorData['executor_type'] = this.executor_type;
      apiExecutorData['executor_name'] = this.executor.executor_name;
      apiExecutorData['executor_version'] = this.executor.executor_version;
      apiExecutorData['executor_display_name'] = this.executor.executor_display_name;
      apiExecutorData['executor_description'] = this.executor.executor_description;
      apiExecutorData['executor_category'] = this.executor.executor_category;
      apiExecutorData['executor_category_group'] = this.executor.executor_category_group;
      apiExecutorData['executor_scope'] = this.executor.scopeOfAccess;
      apiExecutorData['registeredAsIs'] = this.executor.registeredAsIs;
      if (this.executor.hasOwnProperty('service_provider')) {
        apiExecutorData['service_provider'] = this.executor.service_provider;
      }
    }

    const dialogRef = this.dialog.open(DeployAsApiComponent, {
      width: '60%',
      data: apiExecutorData
    });

    const str = this.executor_url.slice(this.executor_url.indexOf('://') + 3);
    const proto = this.executor_url.substring(0, this.executor_url.indexOf(':'));
    let port = 80;
    let dataroot = '';
    let host = '';
    if (str.search(':') === -1) {
      if (proto === 'https') {
        port = 443;
        host = str.substring(0, str.indexOf('/'));
        dataroot = str.substring(str.indexOf(host) + host.length, str.length);
      } else {
        host = str.substring(0, str.indexOf('/'));
        dataroot = str.substring(str.indexOf(host) + host.length, str.length);
      }
    } else {
      port = +str.substring(str.indexOf(':') + 1, str.indexOf('/'));
      host = host = str.substring(0, str.indexOf(':'));
      dataroot = str.substring(str.indexOf('/'), str.length);

    }
    const temp = dataroot.split('?');
    dataroot = temp[0];

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.executorName = dialogRef.componentInstance.executor_name;
        this.executorVersion = dialogRef.componentInstance.executor_version;

        for (let i = this.parameterData.length - 1; i >= 0; i--) {
          if (this.parameterData[i]) {
            if (this.parameterData[i]['key'] === '' && this.parameterData[i]['value'] === '') {
              this.parameterData.splice(i, 1);
            }
          }
        }

        for (let i = this.headersData.length - 1; i >= 0; i--) {
          if (this.headersData[i]) {
            if (this.headersData[i]['key'] === '' && this.headersData[i]['value'] === '') {
              this.headersData.splice(i, 1);
            }
          }
        }

        const apiExecutorSchema = {
          executor_type: 'THIRDPARTY',
          executor_name: dialogRef.componentInstance.executor_name,
          executor_version: dialogRef.componentInstance.executor_version,
          executor_display_name: dialogRef.componentInstance.executor_display_name,
          executor_description: dialogRef.componentInstance.executor_description,
          service_provider: dialogRef.componentInstance.service_provider,
          executor_category: dialogRef.componentInstance.executor_category,
          executor_category_group: dialogRef.componentInstance.executor_category_group,
          published: true,
          scopeOfAccess: dialogRef.componentInstance.executor_scope,
          creationTime: Date.now(),
          lastModifiedTime: Date.now(),
          registeredAsIs: false,
          partner: partner,
          account_id: account,
          executor_method_type: methodType,
          dataroot: null,
          queryParams: this.parameterData,
          headers: this.headersData,
          pathParams: this.pathParameter,
          requestBody: await this.headerChild.getRequestBody(),
          prerequisites: this.prerequisites,
          executors: null,
          responseAttributes: responseAttributes,
          response: null,
          isDocumentationPublished: true,
          mockResponses: this.platform.validateMockResponseData(this.mockResponses),
          isMockResponseEnabled: false
        };
        apiExecutorSchema['authModel'] = this.headerChild.authModel1.getAuthModel();
        apiExecutorSchema['apiUrl'] = this.gatewayUrl + '/' + apiExecutorSchema['executor_version'] + '/' + apiExecutorSchema['executor_name'];

        this.setDevexPropertiesIntoModel(apiExecutorSchema);
        if (apiExecutorSchema.executor_category && apiExecutorSchema.executor_category.length > 0) {

          if (updateExecutor) {
            if (updateExecutor) {
              apiExecutorSchema.creationTime = this.executor['creationTime'];

              if (this.executor.scopeOfAccess !== apiExecutorSchema.scopeOfAccess) {
                apiExecutorSchema['id'] = this.executor.id;
                apiExecutorSchema.scopeOfAccess = this.executor.scopeOfAccess;

                Promise.resolve(this.accessPolicyService.togglePublicAccess(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], apiExecutorSchema)).then(response => {
                  if (response !== 'cancel') {
                    this.isUpdating = false;
                    this.platform.openSnackBar('Updated the API successfully', 'Success', {
                      duration: 5000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                    this.executor = JSON.parse(JSON.stringify(apiExecutorSchema));
                  } else {
                    this.isUpdating = false;
                  }
                }, error => {
                  this.isUpdating = false;
                  this.platform.handleErrorGracefully(error, 'Error while updating the API : ' + apiExecutorSchema.executor_name + '(' + apiExecutorSchema.executor_version + ')');
                });

              } else {
                await this.confPost.updateApiExecutorForPartnerAccount(partner, account, this.executor.id, apiExecutorSchema).toPromise().then(async data => {
                  apiExecutorSchema['id'] = this.executor.id;
                  this.executor = JSON.parse(JSON.stringify(apiExecutorSchema));

                  await this.kongService.updateRouteWithMethods(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], [apiExecutorSchema['executor_method_type']], Date.now(), 'redeploy');

                  this.leftPanelDataListener.changeInLeftPanelDataV2.emit('thirdparty');

                  this.isUpdating = false;
                  this.platform.openSnackBar('Updated the API successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                }, error => {
                  this.isUpdating = false;
                  let errorMessage = '';
                  if (error !== null && error !== undefined && error.error !== null && error.error !== undefined) {
                    if (error.error['message']) {
                      errorMessage = error.error.message;
                    } else {
                      errorMessage = error.error;
                    }
                  }
                  Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_tester_update_success', 'ERROR', error.status, error.statusText, errorMessage, apiExecutorSchema, error, this.router.url)).then(response => {
                    const payloadToSend = {
                      actions: response
                    };
                    this.devexListenerInstance.devexListener.emit({
                      type: 'audit',
                      id: localStorage.getItem('IdOfSession'),
                      payload: payloadToSend
                    });
                  });
                  this.platform.openSnackBar('Error while updating the API : ' + apiExecutorSchema.executor_name + '(' + apiExecutorSchema.executor_version + ')', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                });
              }
              this.executor_name = this.executorName;
              this.executor_version = this.executorVersion;
            }
          } else {
            await this.confPost.insertApiExecutorForPartnerAccount(partner, account, apiExecutorSchema).subscribe(async data => {
              this.platform.createAPIAuditLog(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', apiExecutorSchema);
              const loaderDialog2 = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
              });
              await this.platform.generateAccountRolePermissionGroupAndPermissions(partner, account, localStorage.getItem('signInEmail'), apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', true, timeStamp, '');
              Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_register_apiplatform_success', 'INFO', data.status, data.statusText, '', apiExecutorSchema, data, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              this.executor_name = this.executorName;
              this.executor_version = this.executorVersion;
              let ipRestriction: boolean;
              if (apiExecutorSchema['scopeOfAccess'] === 'public') {
                ipRestriction = false;
              } else {
                ipRestriction = true;
              }
              await this.platform.configureGateway(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], proto, host, dataroot, port, [apiExecutorSchema['executor_method_type']], ipRestriction);
              loaderDialog2.close();

              this.leftPanelDataListener.changeInLeftPanelDataV2.emit('thirdparty');
              this.isUpdating = false;
              this.platform.openSnackBar('Registered the API successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }, error => {
              this.isUpdating = false;
              let errorMessage = '';
              if (error !== null && error !== undefined && error.error !== null && error.error !== undefined) {
                if (error.error['message']) {
                  errorMessage = error.error.message;
                } else {
                  errorMessage = error.error;
                }
              }
              Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_register_apiplatform_failed', 'ERROR', error.status, error.statusText, errorMessage, apiExecutorSchema, error, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              this.platform.openSnackBar('Error while registering the API : ' + apiExecutorSchema.executor_name + '(' + apiExecutorSchema.executor_version + ')', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          }
        } else {
          this.isUpdating = false;
          this.platform.openSnackBar('Enter a valid category', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      } else {
        this.isUpdating = false;
      }
    });

  }

  async registerApiThruDialog(partner, account, apiUrl, methodType, authModel, headers, queryParams, pathParams, requestBody, prerequisites, responseAttributes, isCountOfResAtt, updateExecutor) {
    const apiExecutorData = {};
    this.executor_url = apiUrl;
    apiExecutorData['partner'] = partner;
    apiExecutorData['account'] = account;
    apiExecutorData['apiUrl'] = apiUrl;
    apiExecutorData['authModel'] = authModel;
    apiExecutorData['headers'] = headers;
    apiExecutorData['queryParams'] = queryParams;
    apiExecutorData['pathParams'] = pathParams;
    apiExecutorData['requestBody'] = requestBody;
    apiExecutorData['prerequisites'] = prerequisites;
    apiExecutorData['responseAttributes'] = responseAttributes;
    apiExecutorData['executor_method_type'] = methodType;
    apiExecutorData['isCountOfResAtt'] = isCountOfResAtt;
    apiExecutorData['executor_type'] = 'THIRDPARTY';
    apiExecutorData['registeredAsIs'] = true;

    if (this.executor) {
      apiExecutorData['executor_type'] = this.executor_type;
      apiExecutorData['executor_name'] = this.executor.executor_name;
      apiExecutorData['executor_version'] = this.executor.executor_version;
      apiExecutorData['executor_display_name'] = this.executor.executor_display_name;
      apiExecutorData['executor_description'] = this.executor.executor_description;
      apiExecutorData['executor_category'] = this.executor.executor_category;
      apiExecutorData['executor_category_group'] = this.executor.executor_category_group;
      apiExecutorData['executor_scope'] = this.executor.scopeOfAccess;
      apiExecutorData['registeredAsIs'] = this.executor.registeredAsIs;
      if (this.executor.hasOwnProperty('service_provider')) {
        apiExecutorData['service_provider'] = this.executor.service_provider;
      }
    }

    const urlSplitByQueryParams = apiUrl.split('?');

    for (let i = this.parameterData.length - 1; i >= 0; i--) {
      if (this.parameterData[i]) {
        if (this.parameterData[i]['key'] === '' && this.parameterData[i]['value'] === '') {
          this.parameterData.splice(i, 1);
        }
      }
    }

    for (let i = this.headersData.length - 1; i >= 0; i--) {
      if (this.headersData[i]) {
        if (this.headersData[i]['key'] === '' && this.headersData[i]['value'] === '') {
          this.headersData.splice(i, 1);
        }
      }
    }
    const dialogRef = this.dialog.open(DeployAsApiComponent, {
      width: '60%',
      data: apiExecutorData
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result && result !== null && result !== undefined) {
        this.executorName = dialogRef.componentInstance.executor_name;
        this.executorVersion = dialogRef.componentInstance.executor_version;
        const apiExecutorSchema = {
          executor_type: dialogRef.componentInstance.executor_type,
          executor_name: dialogRef.componentInstance.executor_name,
          executor_version: dialogRef.componentInstance.executor_version,
          executor_display_name: dialogRef.componentInstance.executor_display_name,
          executor_description: dialogRef.componentInstance.executor_description,
          service_provider: dialogRef.componentInstance.service_provider,
          executor_category: dialogRef.componentInstance.executor_category,
          executor_category_group: dialogRef.componentInstance.executor_category_group,
          published: true,
          creationTime: Date.now(),
          lastModifiedTime: Date.now(),
          registeredAsIs: true,
          partner: partner,
          account_id: account,
          executor_method_type: methodType,
          apiUrl: urlSplitByQueryParams[0],
          dataroot: null,
          queryParams: this.parameterData,
          headers: this.headersData,
          pathParams: this.pathParameter,
          requestBody: await this.headerChild.getRequestBody(),
          prerequisites: this.prerequisites,
          executors: null,
          responseAttributes: responseAttributes,
          response: null,
          isDocumentationPublished: true,
          mockResponses: this.platform.validateMockResponseData(this.mockResponses),
          isMockResponseEnabled: false
        };
        apiExecutorSchema['authModel'] = this.headerChild.authModel1.getAuthModel();
        this.setDevexPropertiesIntoModel(apiExecutorSchema);
        if (apiExecutorSchema.executor_category && apiExecutorSchema.executor_category.length > 0) {
          if (updateExecutor) {
            apiExecutorSchema.creationTime = this.executor['creationTime'];
            await this.confPost.updateApiExecutorForPartnerAccount(partner, account, this.executor.id, apiExecutorSchema).toPromise().then(async data => {
              apiExecutorSchema['id'] = this.executor.id;
              this.executor = apiExecutorSchema;
              this.platform.updateAPIAuditLog(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', apiExecutorSchema, this.executor);
              Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_tester_update_success', 'INFO', data.status, data.statusText, '', apiExecutorSchema, data, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              this.leftPanelDataListener.changeInLeftPanelDataV2.emit('thirdparty');

              this.platform.openSnackBar('Updated the API successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }, error => {
              let errorMessage = '';
              if (error !== null && error !== undefined && error.error !== null && error.error !== undefined) {
                if (error.error['message']) {
                  errorMessage = error.error.message;
                } else {
                  errorMessage = error.error;
                }
              }
              Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_tester_update_success', 'ERROR', error.status, error.statusText, errorMessage, apiExecutorSchema, error, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              this.platform.openSnackBar('Error while updating the API : ' + apiExecutorSchema.executor_name + '(' + apiExecutorSchema.executor_version + ')', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
            this.executor_name = this.executorName;
            this.executor_version = this.executorVersion;
          } else {
            const timeStamp = Date.now();
            await this.confPost.insertApiExecutorForPartnerAccount(partner, account, apiExecutorSchema).toPromise().then(async data => {
              this.platform.createAPIAuditLog(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', apiExecutorSchema);
              const loaderDialog1 = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
              });
              await this.platform.generateAccountRolePermissionGroupAndPermissions(partner, account, localStorage.getItem('signInEmail'), apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', true, timeStamp, '');
              loaderDialog1.close();
              Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'devex_register_asis_success', 'INFO', data.status, data.statusText, '', apiExecutorSchema, data, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              const log_payload = {
                logType: 'INFO',
                logLevel: 0,
                slugSearch: '',
                label: 'devex_register_asis_success',
                featureArea: this.platform.auditFeatureArea.tester,
                resource: 'API_REGISTER_AS_IS',
                action: 'CLICK',
                result: 'SUCCESS',
                payload: apiExecutorSchema,
                responseStatusCode: data.status,
                response: data,
                errorMessage: '',
                logMessage: 'API is registered successfully'
              };
              this.auditLog.log(log_payload);
              await this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').toPromise().then(data => {
                this.platform.isRegisterTAB = 'true';
                this.platform.updatedThirdAPI = JSON.stringify({
                  'entityName': apiExecutorSchema['executor_name'],
                  'version': apiExecutorSchema['executor_version']
                });
              });
              this.leftPanelDataListener.changeInLeftPanelDataV2.emit('thirdparty');
              this.platform.openSnackBar('Registered the API successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }, error => {
              let errorMessage = '';
              if (error !== null && error !== undefined && error.error !== null && error.error !== undefined) {
                if (error.error['message']) {
                  errorMessage = error.error.message;
                } else {
                  errorMessage = error.error;
                }
              }
              Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'devex_register_asis_failed', 'ERROR', error.status, error.statusText, errorMessage, apiExecutorSchema, error, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.devexListenerInstance.devexListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              const log_payload = {
                logType: 'ERROR',
                logLevel: 0,
                slugSearch: '',
                label: 'devex_register_asis_failed',
                featureArea: this.platform.auditFeatureArea.tester,
                resource: 'API_REGISTER_AS_IS',
                action: 'CLICK',
                result: 'SUCCESS',
                payload: apiExecutorSchema,
                responseStatusCode: error.status,
                response: error,
                errorMessage: errorMessage,
                logMessage: 'Error while registering the API'
              };
              this.auditLog.log(log_payload);
              this.platform.openSnackBar('Error while registering the API : ' + apiExecutorSchema.executor_name + '(' + apiExecutorSchema.executor_version + ')', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
            this.executor_name = this.executorName;
            this.executor_version = this.executorVersion;
            // this.configureApiGatewayAsIs();
          }
        } else {
          this.isUpdating = false;
          this.platform.openSnackBar('Enter a valid category', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
      this.isUpdating = false;
    });
  }

  updateTabName(method, apiUrl) {
    this.tabNameChanged.emit({method: method, apiUrl: apiUrl});
  }

  createMarginRight() {
    document.getElementById(this.componentType).style.paddingRight = '400px';
  }

  removeMarginRight() {
    document.getElementById(this.componentType).style.paddingRight = '0px';
  }

  onEntityApiResponseChange(updatedApiResponse: any) {
    this.items.apiResponses = updatedApiResponse;
  }

  htmlViewChange(value: any) {
    this.htmlViewType = value;
  }

  copyToClipboard() {
    const ele_textAsResponse = document.querySelector('#textAsResponse');
    if (this.codeViewer) {
      const textToCopy = this.codeViewer.getContent();
      navigator.clipboard.writeText(textToCopy);
    } else if (ele_textAsResponse !== null) {
      const textToCopy = ele_textAsResponse.textContent;
      navigator.clipboard.writeText(textToCopy);
    }
    this.platform.openSnackBar('Copied to clipboard.', 'Success', {
      duration: 2000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
